import { useRouter } from "next/router";
import { withGlobalPageSpinner } from "../../../../components/GlobalPageSpinner";
import { V3EmbedCollection } from "../../../../components/V3EmbedCollection";
import { EmbedTheme } from "../../../../utils/embeds";
import { V3EmbedUnavailable } from "../../../../components/V3EmbedUnavailable";
import { NoIndexHead } from "../../../../components/NoIndexHead";
import { buildContentFilterQueryParams } from "../../../../pagelayouts/content/utils/buildContentFilterQueryParams";
import { getContentInfiniteQuerie } from "../../../../utils/query-utils/contentInfiniteQuerie";
import { getPublicUserClient } from "../../../../utils/getAuthor";
import { getPublicCollectionClient } from "../../../../utils/query-utils/getCollection";
import { PublicCollectionShareStatusResponse } from "@authory-packages/core";
import { ShareStatus } from "@authory-packages/core";
import { getServerSidePropsWithCollection } from "../../../../pagelayouts/collection-details/CollectionDetailsPublicPageLayoutContainer";

export default function CollectionEmbedPage({ collectionShareStatus }: { collectionShareStatus: PublicCollectionShareStatusResponse }) {
    const router = useRouter();
    const authorSlug = router.query.author as string;

    // Get the collection
    const { collection } = getPublicCollectionClient(true, false, collectionShareStatus);

    // Get the author
    const { author } = getPublicUserClient();
    const searchArgs = { collection: router.query.collectionAccessKey as string };
    const params = buildContentFilterQueryParams(searchArgs, true, undefined, true);
    const articles = getContentInfiniteQuerie(
        null,
        authorSlug,
        params,
        !collectionShareStatus.isPasswordProtected && collectionShareStatus.shareStatus !== ShareStatus.Unpublished
    );

    const numItems = typeof router.query.numItems === "string" ? parseInt(router.query.numItems) : 0;

    const authorDoesNotExist = !author.isLoading && !author.data;
    const collectionDoestNotExist = !collection.isLoading && !collection.data;
    const itemsDoNotExist = !articles.isLoading && !articles.data;

    const isUnavailable = authorDoesNotExist || collectionDoestNotExist || itemsDoNotExist;

    return (
        <>
            <NoIndexHead nofollow />
            {isUnavailable ? (
                <V3EmbedUnavailable />
            ) : (
                withGlobalPageSpinner(
                    author.isLoading || collection.isLoading || articles.isLoading,
                    <V3EmbedCollection
                        author={author.data!}
                        collection={collection.data}
                        embedTheme={typeof router.query.theme === "string" ? (router.query.theme as EmbedTheme) : undefined}
                        showHeader={typeof router.query.showHeader === "string" ? router.query.showHeader === "true" : undefined}
                        items={articles.data?.pages[0].articles.slice(0, numItems) || []}
                    />
                )
            )}
        </>
    );
}

export const getServerSideProps = getServerSidePropsWithCollection(false, false);
